import { LoadingButton } from '@airship-platform/jam-web/components';
import Button from '@mui/material/Button';
import Grid, { GridProps } from '@mui/material/Grid';
import { PropsWithChildren } from 'react';
import OnboardingStepsList from './OnboardingStepsList';

type OnboardingWrapperProps = GridProps & {
  onSaveClick?: {
    onClick: () => void;
  };
  onNextClick?: {
    onClick: () => void;
    isLoading?: boolean;
  };
  onFinishClick?: {
    onClick: () => void;
    isLoading?: boolean;
  };
  onPreviousClick?: () => void;
  buttonLabel?: string;
  currentStep?: number;
};

const OnboardingWrapper: React.FC<
  PropsWithChildren<OnboardingWrapperProps>
> = ({
  onSaveClick,
  onNextClick,
  onPreviousClick,
  onFinishClick,
  children,
  buttonLabel = 'Save & exit setup',
  currentStep,
}) => (
  <Grid
    sx={{
      position: 'relative',
      marginTop: '1.5rem',
      padding: '1.5rem',
      overflow: 'hidden',
      bgcolor: (theme) => theme.palette.common.white,
      boxShadow:
        '0px 2px 8px -2px rgba(21, 21, 21, 0.08), 0px 12px 16px -4px rgba(21, 21, 21, 0.08);',
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      justifyContent: 'center',
      width: '100%',
      height: '89vh',
    }}
  >
    {currentStep && (
      <Grid
        sx={{
          position: 'absolute',
          top: '1.5rem',
          left: '1.5rem',
        }}
      >
        <OnboardingStepsList currentStep={currentStep} />
      </Grid>
    )}
    {onSaveClick && (
      <Grid
        sx={{
          position: 'absolute',
          top: '1.5rem',
          right: '1.5rem',
        }}
      >
        <Button
          size="medium"
          variant="outlined"
          color="gray"
          onClick={onSaveClick.onClick}
        >
          {buttonLabel}
        </Button>
      </Grid>
    )}
    <Grid
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 3,
        maxWidth: '25rem',
      }}
    >
      {children}

      <Grid
        sx={{
          display: 'flex',
          width: '100%',
          justifyContent: onPreviousClick ? 'space-between' : 'flex-end',
        }}
      >
        {onPreviousClick && (
          <Button
            onClick={onPreviousClick}
            size="large"
            variant="outlined"
            color="gray"
          >
            Previous
          </Button>
        )}
        {onNextClick && (
          <LoadingButton
            size="large"
            color="primary"
            loading={onNextClick.isLoading ?? false}
            onClick={onNextClick.onClick}
            disabled={onNextClick.isLoading}
          >
            {'Next'}
          </LoadingButton>
        )}
        {onFinishClick && (
          <LoadingButton
            size="large"
            onClick={onFinishClick.onClick}
            loading={onFinishClick.isLoading ?? false}
            disabled={onFinishClick.isLoading}
            fullWidth
            sx={{ marginLeft: '1.875rem' }}
          >
            {'Invite and Complete Setup'}
          </LoadingButton>
        )}
      </Grid>
    </Grid>
  </Grid>
);

export default OnboardingWrapper;
